import { CalendarView } from "angular-calendar";

export enum CalendarViewType {
	MONTH = CalendarView.Month,
	WEEK = CalendarView.Week,
}
